import { __assign } from "tslib";
import { error, pending, success } from './promise-middleware-utils';
function toStateObj(array, key, addProperties) {
    var state = {};
    array.forEach(function (obj) {
        if (obj) {
            state[obj[key]] = Object.assign({}, obj, addProperties);
        }
        else {
            console.warn('toStateObj: array contained an undefined', array);
        }
    });
    return state;
}
function addIdToAllObjectFields(obj) {
    var state = {};
    Object.keys(obj).forEach(function (key) { return state[key] = Object.assign({ id: key }, obj[key]); });
    return state;
}
function stateObjToArray(obj) {
    return Object.keys(obj).map(function (id) { return (__assign({ id: id }, obj[id])); });
}
var throwDeprecationWarning = function (message) {
    console.warn("DEPRECATED (chat-sdk): " + message);
};
var throwDeprecationError = function (message) {
    var s = "DEPRECATED (chat-sdk): " + message;
    console.warn(s);
    throw new Error(s);
};
var toArray = function (obj) { return Object.keys(obj).map(function (key) { return obj[key]; }); };
export { success, error, pending, toStateObj, stateObjToArray, addIdToAllObjectFields, toArray, throwDeprecationWarning, throwDeprecationError, };
